/**
 * supabase-js returns PostgrestError as a plain object, not an Error, so a
 * caller's `err instanceof Error ? err.message : "..."` fell back to a generic
 * message (2026-10-15 "Export failed"). Wrap it in a real Error that keeps the
 * PostgREST message and SQLSTATE `code` (e.g. 57014 = statement timeout).
 * 57014 is also raised by a manual cancel; the export treats both as "timed
 * out", which is what a user would see in practice.
 */
export function toRpcError(
  what: string,
  error: { message?: string; code?: string },
): Error & { code?: string } {
  // `cause` keeps the full PostgrestError (details, hint) for console logs.
  const e = new Error(`${what}: ${error.message || "unknown database error"}`, {
    cause: error,
  }) as Error & { code?: string };
  e.code = error.code;
  return e;
}

/**
 * Message for a failed export. Handles real Errors and raw PostgrestError-like
 * objects ({ message, code }); SQLSTATE 57014 (statement timeout) gets an
 * actionable message instead of the database text.
 */
export function exportErrorMessage(err: unknown): string {
  const e = err as { code?: unknown; message?: unknown } | null;
  if (e && e.code === "57014") {
    return "The export timed out. Narrow the filters and try again.";
  }
  if (e && typeof e.message === "string" && e.message.trim() !== "") {
    return `Export failed: ${e.message}`;
  }
  return "Export failed";
}
